import { Pipe, PipeTransform } from '@angular/core';
import { BENEFIT_NAME } from '@app/config/benefit-name.enum';

@Pipe({
  name: 'benefitIcon'
})
export class BenefitIconPipe implements PipeTransform {

  transform(value: number): string {

    value = Number(value);

    const ix: number = BENEFIT_NAME.findIndex(e => e.id === value);

    if (ix !== -1)
      return BENEFIT_NAME[ix].ico;

    return '';
  }
}
